import React from 'react';
import './Glosario.css';

const Glosario = ({ returnableObject = null, settableKeyValue = "", settableObjectValue = "", unselectWordHandler = null, selectWordHandler = null, glosarioData = [], glosarioSelected = [], accesableKey = "palabra", selectedKey = "id", handlerSearch = null, placeHolderTextSearch = "Busque una palabra", glosarioFiltred = []}) => {
    let abecedario = [];
    let strabc =  'ABCDEFGHIJKLMNÑOPQRSTUVWXYZ';
    if(glosarioData !== null && glosarioData.length > 0){
        [...strabc].forEach(letra => {
            if(glosarioFiltred.length > 0){
                let palabrasSegunLetra = glosarioFiltred.filter((p)=>{ return p[accesableKey].toUpperCase().startsWith(letra) })
                abecedario[letra] = palabrasSegunLetra
            }else{
                let palabrasSegunLetra = glosarioData.filter((p)=>{ return p[accesableKey].toUpperCase().startsWith(letra) })
                abecedario[letra] = palabrasSegunLetra
            }
            
        });
    }else{
        return false
    }

    return (
        <div className="glosarioContainer">
            <div className="searchContainer">
                <label htmlFor=""><i className='fas fa-search'></i> Buscar</label>
                <input type="text" onChange={(e)=>{handlerSearch(e.currentTarget.value)}} placeholder={placeHolderTextSearch} />
            </div>
            <div className="LetrasContainer">
            {
            [...strabc].map((letra, i) => {
                // if(abecedario[letra].length !== 0){}
                return (
                    <div key={i} className="glosarioPalabrasContainer">
                        <h3>{letra}</h3>
                        <div className="palabras">
                        {
                            abecedario[letra].map((p, j) => {
                                return (
                                    <p key={j} className={`${p.selected ? "selected" : ""}`} onClick={(e)=>{
                                        if(p.selected){
                                            // e.currentTarget.classList.remove("selected")
                                            unselectWordHandler(p)
                                        }
                                        else{
                                            // e.currentTarget.classList.add("selected")
                                            selectWordHandler(p)
                                        }
                                        }}
                                    >{p[accesableKey]}</p>
                                )
                            })
                        }
                        </div>
                    </div>
                )
            })
           }
            </div>
        </div>
    );
}
export default Glosario;